import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRestricted = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M32.5714 8C30.9935 8 29.7143 9.34315 29.7143 11V34.4H28.5714V15.8C28.5714 14.1431 27.2922 12.8 25.7143 12.8C24.1363 12.8 22.8571 14.1431 22.8571 15.8V39.2H21.7143V27.8C21.7143 26.1431 20.4351 24.8 18.8571 24.8C17.2792 24.8 16 26.1431 16 27.8V38.2118C16 48.0359 23.1634 56 32 56C40.8366 56 48 48.0359 48 38.2118V22.4C48 21.0745 46.9767 20 45.7143 20C44.4519 20 43.4286 21.0745 43.4286 22.4V35.6H42.2857V14.6C42.2857 12.9431 41.0065 11.6 39.4286 11.6C37.8506 11.6 36.5714 12.9431 36.5714 14.6V34.4H35.4286V11C35.4286 9.34315 34.1494 8 32.5714 8ZM33.7143 50C33.7143 45.6922 30.3884 42.2 26.2857 42.2V41C31.0196 41 34.8571 45.0294 34.8571 50H33.7143Z",
		fill: "#A7ACB3"
	})
});
export default SvgRestricted;
